import React from 'react';
import PropTypes from 'prop-types';
import TmntText from '../tmnt-text/tmnt-text';

export default function ReturnReason({
  selectedProductComments,
  orderLineKey,
}) {
  const values = [
    selectedProductComments?.reason2?.value,
    selectedProductComments?.reason3?.value,
  ].filter(Boolean);

  if (values.length === 0) return null;

  const [
    first,
    second,
  ] = values;

  return (
    <div className="return-reason" data-testid={`return-reason-${orderLineKey}`}>
      <TmntText k="DRE_RETURN_REASON" />
      <span>: </span>
      <TmntText k={`DRE_${first}`} />
      {second && (
        <>
          <span>, </span>
          <TmntText k={`DRE_${second}`} />
        </>
      )}
    </div>
  );
}

ReturnReason.propTypes = {
  selectedProductComments: PropTypes.object,
  orderLineKey: PropTypes.string,
};
